/* eslint-disable no-console */
import { EventEmitter } from "events";
import debugFactory from "debug";

const DEFAULT = Symbol();

class EntityCache extends EventEmitter {
	id;
	cache = new Map();
	debug;

	constructor( id = "" ) {
		super();
		this.id = id;
		this.debug = debugFactory( `teaming:common-io:iocache:${ this.id }` );
	}

	set( key, response ) {
		key = `${ key }`;
		this.debug( `set: ${ key }` );
		this.emit( "setting", { key, response, } );
		this.cache.set( key, response );
		this.emit( "set", { key, response, } );
	}

	has( key ) {
		return this.cache.has( `${ key }` );
	}

	get( key, defaultTo = DEFAULT, addToCache = true ) {
		key = `${ key }`;
		this.emit( "getting", { key, } );
		const response = this.cache.get( key );
		if ( response ) {
			this.debug( `get (HIT): ${ key }` );
			this.emit( "gotten", { key, } );
			return response;
		}
		this.debug( `get (MISS): ${ key }` );
		if ( defaultTo !== DEFAULT ) {
			if ( addToCache ) {
				this.set( key, defaultTo );
			}
			this.emit( "gotten", { key, } );
			return defaultTo;
		}
		return undefined;
	}

	getAll( keys ) {
		return keys.map( key => this.get( key ) );
	}

	remove( key ) {
		key = `${ key }`;
		this.debug( `remove: ${ key }` );
		this.emit( "removing", { key, } );
		const response = this.get( key );
		this.cache.delete( key );
		this.emit( "removed", { key, response, } );
	}

	removeBy( criteria = _ => false, keyFilterExpression = /.*/ ) {
		const keysToRemove = [];
		const filteredKeys = Array.from( this.cache.keys() )
			.filter( key => !!key.matches( keyFilterExpression ) );
		for ( const filteredKey of filteredKeys ) {
			const response = this.get( filteredKey );
			if ( criteria( { key: filteredKey, response, } ) ) {
				keysToRemove.push( filteredKey );
			}
		}
		this.removeAll( keysToRemove );
	}

	removeAll( keys ) {
		for ( const key of keys ) {
			this.remove( key );
		}
	}

	clear() {
		this.debug( "clear" );
		this.emit( "clearing" );
		this.cache.clear();
		this.emit( "cleared" );
	}

	toString() {
		const obj = Array.from( this.cache.keys() ).reduce( ( json, key ) => {
			json[ key ] = this.get( key );
			return json;
		}, {} );

		return JSON.stringify( obj );
	}

	toJSON() {
		return JSON.parse( this.toString() );
	}
}

export const teamCache = new EntityCache( "team" );
export const goalCache = new EntityCache( "goal" );
export const goalActivityCache = new EntityCache( "goalActivity" );
